import Link from "next/link";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Topdial.ng</h3>
            <p className="text-gray-300 mb-4">
              Your trusted platform for premium property listings in Nigeria.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/share/19VqC9Qm6o/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white"
              >
                <FaFacebook size={24} />
              </a>
              <a
                href="https://x.com/topdialservices"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white"
              >
                <FaXTwitter size={24} />
              </a>
              <a
                href="https://www.instagram.com/topdialservices"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white"
              >
                <FaInstagram size={24} />
              </a>
              <a href="#" className="text-gray-300 hover:text-white">
                <FaLinkedin size={24} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            {/* Both Desktop and Mobile: 2x3 Grid */}
            <div className="grid grid-cols-2 gap-x-1 gap-y-2">
              <Link
                href="/auth/sign-in"
                className="text-gray-300 hover:text-white block"
              >
                Sign In
              </Link>
              <Link
                href="/auth/sign-up"
                className="text-gray-300 hover:text-white block"
              >
                Sign Up
              </Link>
              <Link
                href="/listings"
                className="text-gray-300 hover:text-white block"
              >
                Listings
              </Link>
              <Link href="/" className="text-gray-300 hover:text-white block">
                Home
              </Link>
              <Link
                href="/about"
                className="text-gray-300 hover:text-white block"
              >
                About Us
              </Link>
              <Link
                href="/contact"
                className="text-gray-300 hover:text-white block"
              >
                Contact
              </Link>
            </div>
          </div>

          {/* Information */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Information</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  href="/static/terms"
                  className="text-gray-300 hover:text-white"
                >
                  Terms
                </Link>
              </li>
              <li>
                <Link
                  href="/static/privacy"
                  className="text-gray-300 hover:text-white"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link href="/faq" className="text-gray-300 hover:text-white">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <div className="space-y-2 text-gray-300">
              <p>Email: info@topdial.ng</p>
              <p>Support: support@topdial.ng</p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 mt-10 pt-6 text-center text-gray-400">
          <p>© {year} Topdial Services. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
